import { useEffect } from "react";
import { usePostMessage } from "@/hooks/usePostMessage";
import { createNavigateHandler } from "@/services/postMessage/handlers/NavigateHandler";

export function EmbedNavigateListener() {
  const isInIframe = typeof window !== "undefined" && window.self !== window.top;
  const service = usePostMessage({ enabled: isInIframe });

  useEffect(() => {
    if (!service || !isInIframe) return;
    const handler = createNavigateHandler();
    const unsubscribe = service.subscribe("NAVIGATE", handler);
    return () => unsubscribe();
  }, [service, isInIframe]);

  return null;
}

